export const BASE_URL = process.env.REACT_APP_BASE_URL;

export const BED_SIZE_OPTIONS = [
  "0-50",
  "50-100",
  "100-250",
  "250-500",
  "500+",
];
